import type { Theme } from '@emotion/react';
import { useEffect, useState } from 'react';

import { useEventListener } from '@innovamat/hooks';

import type { Classroom } from '../../../modules/classroom';

type Props = {
  classrooms: Classroom[];
  theme: Theme;
};

type UseClassesDisplay = {
  noClasses: boolean;
  isExtendable: boolean;
};

function useClassesDisplay({ classrooms, theme }: Props): UseClassesDisplay {
  const [isExtendable, setIsExtendable] = useState(false);
  const preprocessedClassrooms = classrooms ?? [];

  const noClasses = preprocessedClassrooms.length === 0;

  const handleIsExtendable = (width: number, theme: Theme): void => {
    const mdBreakpoint = parseInt(theme.breakpoints.md);
    const smBreakpoint = parseInt(theme.breakpoints.sm);

    if (width > mdBreakpoint) {
      setIsExtendable(classrooms.length > 6);
    } else if (width > smBreakpoint && width <= mdBreakpoint) {
      setIsExtendable(classrooms.length > 4);
    } else {
      setIsExtendable(classrooms.length > 2);
    }
  };

  useEffect(() => {
    const screenWidth =
      typeof window !== 'undefined' ? window.innerWidth : 1080;
    handleIsExtendable(screenWidth, theme);
  }, [classrooms]);

  useEventListener('resize', () => {
    const screenWidth =
      typeof window !== 'undefined' ? window.innerWidth : 1080;
    handleIsExtendable(screenWidth, theme);
  });

  return {
    noClasses,
    isExtendable,
  };
}

export { useClassesDisplay };
export type { UseClassesDisplay };
